<!-- Address search -->
<div class="flex gap-2 items-center">
  <mat-form-field class="flex-1">
    <mat-label>{{ 'location-picker.address-search' | translate }}</mat-label>
    <input
      matInput
      #addrInput
      [value]="addressQuery()"
      (input)="addressQuery.set(addrInput.value)"
      (keyup.enter)="searchAddress()" />
  </mat-form-field>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [matTooltip]="'location-picker.address-search' | translate"
    (click)="searchAddress()">
    <mat-icon>search</mat-icon>
  </button>
</div>

<!-- Map -->
@if (mapsReady()) {
  <google-map
    height="420px"
    width="100%"
    [center]="mapCenter()"
    [zoom]="mapZoom()"
    (mapClick)="onMapClick($event)">
    @if (markerPosition()) {
      <map-marker
        [position]="markerPosition()!"
        [options]="{ draggable: true }"
        (mapDragend)="onMarkerDragEnd($event)" />
    }
  </google-map>
} @else {
  <div class="flex items-center justify-center h-40 rounded border border-dashed border-gray-300 text-gray-400 text-sm">
    {{ 'location-picker.no-maps' | translate }}
  </div>
}

<!-- Coordinates display -->
<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
  <mat-form-field>
    <mat-label>{{ 'location-picker.latitude' | translate }}</mat-label>
    <input matInput [formControl]="latControl()" [readonly]="true" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'location-picker.longitude' | translate }}</mat-label>
    <input matInput [formControl]="lngControl()" [readonly]="true" />
  </mat-form-field>
</div>

<p class="text-xs text-gray-500">{{ 'location-picker.hint' | translate }}</p>
